import { customStockBalance } from 'integration/generated/custom';
import { CustomStockBalanceResult } from 'integration/generated/custom/data-contracts';

/**
 * This REST service method returns stock information
 */
export const DATA_KEY = 'customStockBalance';

export const fetcher =
	(pub: boolean) =>
	/**
	 * The data fetcher for Jeeves sales API: stock balance
	 * @param query The request query.
	 *
	 * @returns Fetched Stock Balance .
	 */
	async (storeId: string, catentryId: string): Promise<CustomStockBalanceResult | undefined> => {
		try {
			return await (customStockBalance(pub).stockBalanceByCatentryId(
				storeId,
				catentryId
			) as Promise<unknown> as Promise<CustomStockBalanceResult>);
		} catch (error: any) {
			console.error(error);
			return undefined;
		}
	};
